/**
 * @fileoverview Server-side services for story planning persistence.
 *
 * All services are marked 'use server' for Next.js Server Actions.
 *
 * Structure services:
 * - `updateStoryStructure` - Update POV, genre, tense, plot, etc.
 *
 * Utility services:
 * - `computePlotScopeGuidance` - Compute guidance for plot scope
 */

export * from './update-story-structure';
export * from './update-written-plot-with-sync';
export * from './compute-plot-scope-guidance';
export * from './continuity-fact-repository';
